import {createSelector} from 'reselect';

export const getForgotPasswordChanged = ({forgotPasswordChanged}) =>
  forgotPasswordChanged;
export const getIsForgotPasswordChangedSuccess = createSelector(
  getForgotPasswordChanged,
  (forgotPasswordChanged) =>
    forgotPasswordChanged.isForgotPasswordChangedSuccess,
);
